"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxRepeatSeriesInfoArgs = void 0;
var HxDailyPattern_1 = require("./HxDailyPattern");
var HxWeeklyPattern_1 = require("./HxWeeklyPattern");
var HxMonthlyAbsolutePattern_1 = require("./HxMonthlyAbsolutePattern");
var HxMonthlyRelativePattern_1 = require("./HxMonthlyRelativePattern");
var HxYearlyAbsolutePattern_1 = require("./HxYearlyAbsolutePattern");
var HxYearlyRelativePattern_1 = require("./HxYearlyRelativePattern");
var HxNoEndPatternRange_1 = require("./HxNoEndPatternRange");
var HxEndDatePatternRange_1 = require("./HxEndDatePatternRange");
var HxNumberedPatternRange_1 = require("./HxNumberedPatternRange");
function serializeHxRepeatSeriesInfoArgs(_arg) {
    var output = [];
    output.push(_arg.pattern);
    output.push(_arg.dailyPattern !== undefined);
    if (_arg.dailyPattern !== undefined) {
        output.push(HxDailyPattern_1.serializeHxDailyPattern(_arg.dailyPattern));
    }
    output.push(_arg.weeklyPattern !== undefined);
    if (_arg.weeklyPattern !== undefined) {
        output.push(HxWeeklyPattern_1.serializeHxWeeklyPattern(_arg.weeklyPattern));
    }
    output.push(_arg.monthlyAbsolutePattern !== undefined);
    if (_arg.monthlyAbsolutePattern !== undefined) {
        output.push(HxMonthlyAbsolutePattern_1.serializeHxMonthlyAbsolutePattern(_arg.monthlyAbsolutePattern));
    }
    output.push(_arg.monthlyRelativePattern !== undefined);
    if (_arg.monthlyRelativePattern !== undefined) {
        output.push(HxMonthlyRelativePattern_1.serializeHxMonthlyRelativePattern(_arg.monthlyRelativePattern));
    }
    output.push(_arg.yearlyAbsolutePattern !== undefined);
    if (_arg.yearlyAbsolutePattern !== undefined) {
        output.push(HxYearlyAbsolutePattern_1.serializeHxYearlyAbsolutePattern(_arg.yearlyAbsolutePattern));
    }
    output.push(_arg.yearlyRelativePattern !== undefined);
    if (_arg.yearlyRelativePattern !== undefined) {
        output.push(HxYearlyRelativePattern_1.serializeHxYearlyRelativePattern(_arg.yearlyRelativePattern));
    }
    output.push(_arg.patternRange);
    output.push(_arg.noEndPatternRange !== undefined);
    if (_arg.noEndPatternRange !== undefined) {
        output.push(HxNoEndPatternRange_1.serializeHxNoEndPatternRange(_arg.noEndPatternRange));
    }
    output.push(_arg.endDatePatternRange !== undefined);
    if (_arg.endDatePatternRange !== undefined) {
        output.push(HxEndDatePatternRange_1.serializeHxEndDatePatternRange(_arg.endDatePatternRange));
    }
    output.push(_arg.numberedPatternRange !== undefined);
    if (_arg.numberedPatternRange !== undefined) {
        output.push(HxNumberedPatternRange_1.serializeHxNumberedPatternRange(_arg.numberedPatternRange));
    }
    return output;
}
exports.serializeHxRepeatSeriesInfoArgs = serializeHxRepeatSeriesInfoArgs;
